import { UserConsentId, UserConsentType } from '@paid-ui/enums/consent';

export const consentIdTypeMap: Record<UserConsentId, UserConsentType> = {
  [UserConsentId.SERVICE_AGREEMENT]: UserConsentType.PAID_SERVICE_AGREEMENT,
  [UserConsentId.PRIVACY_POLICY]: UserConsentType.PAID_PRIVACY_POLICY,
  [UserConsentId.FINANCIAL_SERVICE_GUIDE]: UserConsentType.PAID_FINANCIAL_SERVICE_GUIDE,
  [UserConsentId.PRODUCT_DISCLOSURE_STATEMENT]: UserConsentType.PAID_PRODUCT_DISCLOSURE_STATEMENT,
  [UserConsentId.MARKET_DETERMINATION]: UserConsentType.PAID_MARKET_DETERMINATION,
  [UserConsentId.TMD_SAVINGS_ACCOUNT]: UserConsentType.PAID_TMD_SAVINGS_ACCOUNT,
  [UserConsentId.USER_BACKGROUND_CHECK_AGREEMENT]: UserConsentType.PAID_BACKGROUND_CHECK,
};

export const consentIdTitleMap: Record<UserConsentId, string> = {
  [UserConsentId.SERVICE_AGREEMENT]: 'Paid Service Agreement',
  [UserConsentId.PRIVACY_POLICY]: 'Paid Privacy Policy',
  [UserConsentId.FINANCIAL_SERVICE_GUIDE]: 'Paid - Financial Services Guide',
  [UserConsentId.PRODUCT_DISCLOSURE_STATEMENT]: 'Product Disclosure Statement',
  [UserConsentId.MARKET_DETERMINATION]: 'Target Market Determination (TMD)',
  [UserConsentId.TMD_SAVINGS_ACCOUNT]: 'Target Market Determination Paid Savings Account',
  [UserConsentId.USER_BACKGROUND_CHECK_AGREEMENT]: 'User Background Check Agreement',
};
